var map = {
	"./arr-g.png": 609,
	"./arr-r.png": 610,
	"./arr-y.png": 611,
	"./high-left-2.png": 612,
	"./high-left-3.png": 613,
	"./high-left-4.png": 614,
	"./high-middle-2.png": 615,
	"./high-middle-3.png": 616,
	"./high-middle-4.png": 617,
	"./high-none-2.png": 618,
	"./high-none-3.png": 619,
	"./high-none-4.png": 620,
	"./high-right-2.png": 621,
	"./high-right-3.png": 622,
	"./high-right-4.png": 623,
	"./high-twoedge-2.png": 624,
	"./high-twoedge-3.png": 625,
	"./high-twoedge-4.png": 626,
	"./low-2.png": 627,
	"./low-3.png": 628,
	"./low-4.png": 629,
	"./middle-left-2.png": 630,
	"./middle-left-3.png": 631,
	"./middle-left-4.png": 632,
	"./middle-middle-2.png": 633,
	"./middle-middle-3.png": 634,
	"./middle-middle-4.png": 635,
	"./middle-none-2.png": 636,
	"./middle-none-3.png": 637,
	"./middle-none-4.png": 638,
	"./middle-right-2.png": 639,
	"./middle-right-3.png": 640,
	"./middle-right-4.png": 641,
	"./middle-twoedge-2.png": 642,
	"./middle-twoedge-3.png": 643,
	"./middle-twoedge-4.png": 644
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 608;